export default __webpack_public_path__ + "static/media/Hospital.52a5b37d.jpg";